<template>
    <div>
        <v-menu offset-y>
            <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip top>
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            color="primary"
                            icon
                            v-bind="attrs"
                            v-on="{ ...menu, ...tooltip }"
                        >
                            <v-icon>{{ icons.moreItems }}</v-icon>
                        </v-btn>
                    </template>
                    <div>Change username prefix</div>
                </v-tooltip>
            </template>
            <v-list>
                <v-list-item-group
                    v-model="selectedItem"
                    color="primary"
                    @change="onChange"
                >
                    <v-list-item
                        v-for="(item, index) in items"
                        :key="`prefix-${index}`"
                    >
                        <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'PrefixSelect',
    props: {
        value: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            selectedItem: null
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(newValue) {
                const newSelectedItem = this.items.findIndex(
                    item => item === newValue
                );
                if (
                    newSelectedItem >= 0 &&
                    newSelectedItem !== this.selectedItem
                ) {
                    this.selectedItem = newSelectedItem;
                }
            }
        }
    },
    methods: {
        onChange(value) {
            const newValue = this.items[value];
            this.$emit('input', newValue);
        }
    }
};
</script>

<style></style>
